const t = {
  interactive: {
    yellow: {
      idle: { light: "#FEC02F", dark: "#FEC848" },
      hover: { light: "#F6AD00", dark: "#FFD573" }
    }
  },
  content: {
    buttonText2: { light: "#000000", dark: "#000000" }
  }
}, o = (e) => ({
  content: {
    buttonText2: t.content.buttonText2[e]
  },
  interactive: {
    yellow: {
      idle: t.interactive.yellow.idle[e],
      hover: t.interactive.yellow.hover[e]
    }
  }
});
export {
  o as generateDeprecatedThemeColors
};
//# sourceMappingURL=deprecatedColors.js.map
